import { Box, Text, VStack } from '@chakra-ui/react'
import type { TaskFieldModuleProps } from '../types'
import FeVisitTimeline from '../../FeVisitTimeline'

/**
 * Details-tab host for FE visit tracking tasks (template module core.fe_visit_tracking).
 * Visit lifecycle events live here so agents are not left with "Unknown module".
 */
export function FeVisitTrackingModule({ task, field }: TaskFieldModuleProps) {
  if (!task?.id) {
    return (
      <Box mb={3}>
        <Text fontSize="sm" color="gray.600">
          Save the task to track field visit events.
        </Text>
      </Box>
    )
  }

  return (
    <VStack align="stretch" spacing={2} mb={3}>
      <Text fontSize="xs" fontWeight="700" color="gray.500">
        {field.label || 'FE visit tracking'}
      </Text>
      <Text fontSize="sm" color="gray.600">
        Field visit lifecycle events from the mobile app appear below. Expenses and detailed visit history are also on
        the Visit events and Expenses tabs.
      </Text>
      <FeVisitTimeline taskId={task.id} />
    </VStack>
  )
}
